import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import * as firebase from 'firebase';
import { MatChipInputEvent, ErrorStateMatcher, MatDialog } from '@angular/material';
import { Subscription } from '../../../../../node_modules/rxjs/Subscription';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Http, Headers } from '@angular/http';
import { ApiService } from '../../../core/services/api.service';
import { tokenCreator } from '../../../core/services/token.service';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { supportsWebAnimations } from '@angular/animations/browser/src/render/web_animations/web_animations_driver';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';

@Component({
    selector: 'app-addtokeywords',
    templateUrl: './addtokeywords.component.html',
    styleUrls: ['./addtokeywords.component.scss'],
})
export class AddtokeywordsComponent implements OnInit, OnDestroy {
    @ViewChild('input') input: ElementRef;
    @ViewChild('f') myForm;
    myControl: FormControl = new FormControl();
    name: FormControl = new FormControl();
    rakip: FormControl = new FormControl();
    myModel = true;
    // checked = false;
    // checked1 = false;
    // checked2 = false;
    indeterminate = false;
    labelPosition = 'after';
    checkVal: any;
    disabled = false;
    roleName: any;
    form: FormGroup;
    formErrors: any;
    company: any;
    showForm = true;
    roles: string;
    text: any = "";
    list = [];
    categories = environment.categoriesModel;
    sub: Subscription;
    brandList = [];
    filteredOptions: Observable<string[]>;
    filteredOptions2: Observable<string[]>;
    brands = [];
    item = [];
    itemIndex: any = null;

    waiter = false;
    constructor(
        private formBuilder: FormBuilder,
        private http: Http,
        private afs: AngularFirestore,
        private httpclient: HttpClient,
        private dialog: MatDialog,
        private api: ApiService
    ) {
        // const firestore = firebase.firestore();
        // const settings = { timestampsInSnapshots: true };
        // firestore.settings(settings);


        this.formErrors = {
            category: {},
            mail: {},
            firstname: {},
            lastname: {},
            role: {},
            name: {},
            // uniqueName: {},
            password: {}
        };
    }
    onRole(event) {
        this.checkVal = [];
        this.checkVal = event.value;
    }


    ngOnInit() {
        this.roles = localStorage.getItem('currentUserRole');

        this.filteredOptions = this.name.valueChanges
            .pipe(
                startWith(''),
                map(val => this.filter(val))
            );
        this.filteredOptions2 = this.rakip.valueChanges
            .pipe(
                startWith(''),
                map(val => this.filter(val))
            );

        this.form = this.formBuilder.group({
            category: ['', Validators.required],
            name: [''],
            criter: ['']

            // uniqueName: ['', Validators.required]
        });
        this.form.valueChanges.subscribe((a) => {

            this.roleName = a.role;

            this.onFormValuesChanged();
        });
        this.form.get('category').valueChanges.subscribe((a) => {
            this.waiter = true;
            this.getBrand(a);
        })
    }

    filter(val: string): string[] {
        return this.brandList.filter(option =>
            option.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
    nested(data) {
        data.forEach(element => {
            return element.name
        })
    }
    getBrand(category) {
        console.log(category);

        // if (this.sub) {
        //   this.sub.unsubscribe();
        // }
        this.brandList = [];

        this.sub = this.afs.collection('brands', ref => ref.where('category', '==', category)).valueChanges().subscribe(data => {
            data.forEach(a => {
                this.brandList.push(a['name']);
            });
            this.waiter = false;



        })


    }
    delete(item, category) {
        console.log(item);
        console.log(category);
        if (this.name.value) {
            this.api.sqlPost('corporate/deleteKeyword', {
                keyword: item.name,
                category: category, uniqueName: this.changeText(this.name.value)
            }).map(res => res.json()).toPromise().then((data) => {
                this.item = [];
                data.forEach(key => {
                    this.item.push({ name: key.keyword });
                });

                // this.selectKeywordBrand(this.changeText(this.name.value), category);
            });
        }
        else {
            this.api.sqlPost('corporate/deleteKeyword', { keyword: item.name, category: category }).map(res => res.json()).toPromise().then(() => {
                this.selectKeyword(category);
            });
        }


    }
    edit(item, index) {
        this.text = item.name;
        this.itemIndex = index;

        // this.api.sqlPost('corporate/editKeyword', { keyword: item.name, category: category }).map(res => res.json()).toPromise().then(() => {
        //     this.selectKeyword(category);
        // })

    }


    onFormValuesChanged() {
        for (const field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.form.get(field);

            if (control && control.dirty && !control.valid) {
                this.formErrors[field] = control.errors;
            }
        }
    }

    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }


    send() {
        let criter = this.form.get('criter').value;
        let category = this.form.get('category').value;
        let name = this.name.value;

        if (this.name.value) {
            let uniqueName = this.changeText(this.name.value);
            this.item.forEach(items => {
                console.log(items)
                this.api.sqlPost('corporate/keywordBrand', {
                    keyword: items.name,
                    category: category,
                    uniqueName: uniqueName

                }).map(res => res.json()).subscribe(d => {
                    console.log(d);
                });
            });

        }
        else {


            this.item.forEach(items => {
                console.log(items)
                this.api.sqlPost('corporate/keywordCategory', {
                    keyword: items.name,
                    category: category

                }).map(res => res.json()).subscribe(d => {
                    console.log(d);
                });
            });
        }
        this.item = [];
        this.form.reset();
        this.name.reset();





        // let createAuth = firebase.auth().createUserWithEmailAndPassword(mail, password);
        // let createUser = createAuth.then(data => {

        //     this.api.sqlPost('corporate/insertCorporateMember', {
        //         uniqueName: uniqueName,
        //         membershipDate: this.dateFormat(date)
        //     }).map(res => res.json()).subscribe(d => {
        //         console.log(d);
        //         console.log(uniqueName);
        //     })
        //     return data.uid;
        // }).then((uid) => {
        //     this.SendVerificationMail({ email: mail, nameto: `${firstname} ${lastname}`, uid: uid, password: password });

        //     this.showForm = false;
        //     setTimeout(() => {
        //         // this.form.reset()
        //         this.showForm = true;
        //         // this.name.reset();
        //         // this.brands = [];
        //         this.waiter = false;
        //     });

        // });
    }

    SendVerificationMail(userinfo: Object) {
        const token = tokenCreator();
        const option = {
            data: {
                customToken: token,
                email: userinfo['email'],
                nameTo: userinfo['nameto'],
                nameFrom: 'bigadvice-Analytics'
            }
        }
        console.log(userinfo);
        console.log(token, 'token');
        this.request(option);

    }
    request(option) {

        const sub = this.httpclient.post('https://api.bigadvice.com/email/sendEmailVerificationCorporate', option.data)
            .subscribe((res) => {
                if (res === "OK") {
                    sub.unsubscribe();
                }
            });
    }
    addCriteria(criter, category) {
        console.log(criter, 'criter');

        if (this.itemIndex !== null && !this.name.value) {

            this.api.sqlPost('corporate/editKeyword',
                { keyword: this.item[this.itemIndex].name, category: category, editKeyword: criter }).map(res => res.json()).toPromise().then(() => {
                    this.selectKeyword(category);
                })
            this.item[this.itemIndex].name = criter;
        }
        else if (this.itemIndex !== null && this.name.value) {
            console.log("girdi");

            this.api.sqlPost('corporate/editKeyword',
                {
                    keyword: this.item[this.itemIndex].name, category: category,
                    editKeyword: criter, uniqueName: this.changeText(this.name.value)
                }).map(res => res.json()).toPromise().then(() => {
                    // this.selectKeyword(category);
                })
            this.item[this.itemIndex].name = criter;
        }
        else {
            this.item.push({ name: criter });
        }
        this.itemIndex = null;
        this.text = "";


    }
    selectKeyword(category) {
        console.log(category);
        this.api.sqlPost('corporate/getKeywordCategory', { category: category }).map(res => res.json()).toPromise().then(data => {
            this.item = [];
            data.forEach(key => {
                this.item.push({ name: key.keyword });
            });
        })

    }
    selectKeywordBrand(uniqueName, category) {
        console.log(uniqueName, category)
        if (uniqueName) {
            let brandName = this.changeText(uniqueName);


            this.api.sqlPost('corporate/insertKeywordBrand', { category: category, uniqueName: brandName }).map(res => res.json()).toPromise().then(data => {
                this.item = [];
                data.forEach(key => {
                    console.log(key);
                    this.item.push({ name: key.keyword });
                });
            });
        }

    }
    addCriteria2(criter2) {
        console.log(criter2, 'criter2');

    }



    dateFormat(data) {
        if (data.length == 10) {
            return data;
        }
        var dd = data.getDate();
        var mm = data.getMonth() + 1; //January is 0!
        var yyyy = data.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        data = yyyy + '-' + mm + '-' + dd;
        return data;
    }
    addSelect(event) {
        let value = event.option.value;
        if (value) {
            console.log(value);

            this.brands.push({ name: value, uniqueName: this.changeText(value) });
            console.log("brands");
            console.log(this.brands);


        }
        this.input.nativeElement.value = null;
    }
    addCategory(event: MatChipInputEvent): void {
        this.brands = [];
        const input = event.input;
        const value = event.value;

        // Add category
        if (value) {
            console.log("value");
            console.log(value);

            this.brands.push({ name: value, uniqueName: this.changeText(value) });
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    removeCategory(category) {
        const index = this.brands.indexOf(category);

        if (index >= 0) {
            this.brands.splice(index, 1);
        }
    }
    ngOnDestroy() {
        if (this.sub)
            this.sub.unsubscribe();
    }

    includeString(role, value) {
        if (role.includes(value)) {
            return role;

        }

    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtokeywords/addtokeywords.component.ts